import React from 'react';

const SideContext = React.createContext({
  setTitle: () => {},
});

export default SideContext;
